import { useNavigate } from '@tanstack/react-router';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useStrictCurrentEnterpriseId } from '@mews-commander/core';
import { LocalizedPageTitle, LocalizedParagraph } from '@mews-commander/ui';
import { NewPublicFormWrapper } from '../style';
import { ChangePasswordForm } from './ChangePasswordForm';

export const WeakPassword = () => {
    const currentEnterpriseId = useStrictCurrentEnterpriseId();
    const navigate = useNavigate();

    return (
        <NewPublicFormWrapper vertical>
            <Stack spacing="500" vertical>
                <LocalizedPageTitle textKey={TextKey.WeakPasswordTitle} />
                <LocalizedParagraph textKey={TextKey.WeakPasswordDescription} />
                <ChangePasswordForm
                    onFormSuccess={async () =>
                        navigate({
                            to: '/$currentEnterpriseId/Dashboard/Index',
                            params: { currentEnterpriseId },
                        })
                    }
                />
            </Stack>
        </NewPublicFormWrapper>
    );
};
